module.exports = __webpack_public_path__ + "img/logo192.33dbdd01.png";